// @ts-nocheck
/**
 * 図鑑システム用スタイル定義
 */

// ========================================
// 共通カラー定義
// ========================================

export const COLORS = {
  // 背景
  bgPrimary: '#1a1a2e',
  bgSecondary: '#16213e',
  bgTertiary: '#0f0f23',
  bgCard: 'linear-gradient(135deg, #1a1a3a 0%, #2a2a4a 100%)',
  bgHover: 'rgba(107, 76, 230, 0.2)',
  bgSelected: 'rgba(107, 76, 230, 0.4)',

  // ボーダー
  borderPrimary: 'rgba(107, 76, 230, 0.5)',
  borderSecondary: 'rgba(255, 255, 255, 0.1)',
  borderHighlight: '#6b4ce6',

  // テキスト
  textPrimary: '#e0e0e0',
  textSecondary: '#a0a0a0',
  textGold: '#ffd700',
  textSuccess: '#4caf50',
  textDanger: '#ff6b6b',

  // アクセント
  accent: '#6b4ce6',
  accentLight: '#9d4ce6',
};

// ========================================
// 画面レイアウト
// ========================================

export const screenStyles = {
  container: {
    minHeight: '100vh',
    background: `linear-gradient(135deg, ${COLORS.bgPrimary} 0%, ${COLORS.bgSecondary} 100%)`,
    color: COLORS.textPrimary,
    fontFamily: "'Noto Sans JP', sans-serif",
    display: 'flex',
    flexDirection: 'column',
  },

  containerMobile: {
    padding: '8px',
    paddingTop: '64px', // 固定ヘッダー分
    paddingBottom: '78px', // 固定フッター分
  },

  containerDesktop: {
    padding: '20px 24px',
  },

  // モバイル用固定ヘッダー
  headerMobile: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    background: 'rgba(26, 26, 46, 0.98)',
    borderBottom: `2px solid ${COLORS.accent}`,
    boxShadow: `0 4px 20px rgba(107, 76, 230, 0.3)`,
    zIndex: 100,
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    flexWrap: 'wrap',
    gap: '12px',
  },

  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: COLORS.textGold,
    margin: 0,
    textShadow: '0 0 10px rgba(255, 215, 0, 0.5)',
  },

  titleMobile: {
    fontSize: '22px',
  },
};

// ========================================
// ナビゲーション
// ========================================

export const navStyles = {
  tabContainer: {
    display: 'flex',
    gap: '8px',
    marginBottom: '16px',
    flexWrap: 'wrap',
  },

  tab: {
    padding: '10px 20px',
    border: 'none',
    borderRadius: '8px',
    background: 'rgba(30, 30, 50, 0.8)',
    color: COLORS.textSecondary,
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
    transition: 'all 0.2s ease',
  },

  tabActive: {
    background: COLORS.bgSelected,
    color: COLORS.textPrimary,
    border: `2px solid ${COLORS.borderHighlight}`,
  },

  tabMobile: {
    padding: '8px 14px',
    fontSize: '12px',
  },

  backButton: {
    padding: '10px 20px',
    border: `2px solid ${COLORS.borderPrimary}`,
    borderRadius: '8px',
    background: 'rgba(30, 30, 50, 0.8)',
    color: COLORS.textPrimary,
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
    transition: 'all 0.2s ease',
  },

  // フッタータブナビゲーション（モバイル用）
  footerTabNavigation: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'space-around',
    padding: '8px 16px',
    paddingBottom: 'calc(8px + env(safe-area-inset-bottom))',
    background: 'rgba(26, 26, 46, 0.98)',
    borderTop: `2px solid ${COLORS.accent}`,
    boxShadow: `0 -4px 20px rgba(107, 76, 230, 0.3)`,
    zIndex: 100,
  },

  footerTab: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 4px',
    border: 'none',
    background: 'transparent',
    color: COLORS.textSecondary,
    fontSize: '11px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    borderRadius: '8px',
    margin: '0 4px',
  },

  footerTabActive: {
    color: COLORS.textGold,
    background: COLORS.bgSelected,
  },

  footerTabIcon: {
    fontSize: '22px',
    marginBottom: '2px',
  },
};

// ========================================
// フィルターパネル
// ========================================

export const filterStyles = {
  panel: {
    background: 'rgba(20, 20, 40, 0.9)',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '16px',
    border: `1px solid ${COLORS.borderSecondary}`,
  },

  row: {
    display: 'flex',
    gap: '12px',
    marginBottom: '12px',
    flexWrap: 'wrap',
    alignItems: 'center',
  },

  label: {
    fontSize: '13px',
    color: COLORS.textSecondary,
    minWidth: '60px',
  },

  filterButton: {
    padding: '6px 12px',
    border: `1px solid ${COLORS.borderSecondary}`,
    borderRadius: '6px',
    background: 'rgba(30, 30, 50, 0.6)',
    color: COLORS.textSecondary,
    cursor: 'pointer',
    fontSize: '12px',
    transition: 'all 0.2s ease',
  },

  filterButtonActive: {
    background: COLORS.bgSelected,
    borderColor: COLORS.borderHighlight,
    color: COLORS.textPrimary,
  },

  searchInput: {
    flex: 1,
    minWidth: '200px',
    padding: '10px 14px',
    border: `1px solid ${COLORS.borderSecondary}`,
    borderRadius: '8px',
    background: 'rgba(30, 30, 50, 0.6)',
    color: COLORS.textPrimary,
    fontSize: '14px',
    outline: 'none',
  },
};

// ========================================
// カードグリッド
// ========================================

export const gridStyles = {
  container: {
    display: 'grid',
    gap: '12px',
    gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
  },

  containerMobile: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
    gap: '8px',
  },

  cardItem: {
    background: COLORS.bgCard,
    borderRadius: '10px',
    padding: '10px',
    cursor: 'pointer',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'transparent',
    transition: 'all 0.2s ease',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '6px',
  },

  cardItemHover: {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(107, 76, 230, 0.3)',
    borderColor: COLORS.borderPrimary,
  },

  cardItemOwned: {
    borderColor: 'rgba(76, 175, 80, 0.5)',
  },

  cardItemNotOwned: {
    opacity: 0.5,
    filter: 'grayscale(0.5)',
  },

  cardImage: {
    width: '100%',
    aspectRatio: '3/4',
    borderRadius: '6px',
    background: 'rgba(0, 0, 0, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px',
  },

  cardName: {
    fontSize: '11px',
    color: COLORS.textPrimary,
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
  },

  cardCost: {
    fontSize: '10px',
    color: COLORS.textSecondary,
  },

  ownedBadge: {
    position: 'absolute',
    top: '4px',
    right: '4px',
    background: COLORS.textSuccess,
    color: '#fff',
    fontSize: '10px',
    padding: '2px 6px',
    borderRadius: '4px',
  },

  notOwnedBadge: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: COLORS.textSecondary,
    fontSize: '24px',
  },
};

// ========================================
// カード詳細
// ========================================

export const detailStyles = {
  container: {
    background: COLORS.bgCard,
    borderRadius: '16px',
    padding: '24px',
    border: `2px solid ${COLORS.borderPrimary}`,
  },

  containerMobile: {
    padding: '16px',
  },

  header: {
    display: 'flex',
    gap: '20px',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },

  imageContainer: {
    width: '200px',
    flexShrink: 0,
  },

  imageMobile: {
    width: '140px',
  },

  infoContainer: {
    flex: 1,
    minWidth: '200px',
  },

  cardName: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: COLORS.textGold,
    marginBottom: '8px',
  },

  cardNameMobile: {
    fontSize: '20px',
  },

  statsRow: {
    display: 'flex',
    gap: '16px',
    marginBottom: '8px',
    flexWrap: 'wrap',
  },

  stat: {
    fontSize: '14px',
    color: COLORS.textSecondary,
  },

  statValue: {
    color: COLORS.textPrimary,
    fontWeight: 'bold',
  },

  effectText: {
    background: 'rgba(0, 0, 0, 0.3)',
    borderRadius: '8px',
    padding: '12px',
    fontSize: '13px',
    lineHeight: '1.6',
    color: COLORS.textPrimary,
    marginTop: '12px',
  },

  tabContent: {
    marginTop: '20px',
    padding: '16px',
    background: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '12px',
  },
};

// ========================================
// 進捗バー
// ========================================

export const progressStyles = {
  container: {
    marginBottom: '16px',
  },

  label: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '6px',
    fontSize: '14px',
  },

  labelName: {
    color: COLORS.textPrimary,
  },

  labelValue: {
    color: COLORS.textSecondary,
  },

  barContainer: {
    height: '20px',
    background: 'rgba(30, 30, 50, 0.8)',
    borderRadius: '10px',
    overflow: 'hidden',
    border: `1px solid ${COLORS.borderSecondary}`,
  },

  barFill: {
    height: '100%',
    background: `linear-gradient(90deg, ${COLORS.accent} 0%, ${COLORS.accentLight} 100%)`,
    borderRadius: '10px',
    transition: 'width 0.5s ease',
  },

  percentage: {
    fontSize: '12px',
    color: COLORS.textSecondary,
    textAlign: 'right',
    marginTop: '4px',
  },
};

// ========================================
// 統計カード
// ========================================

export const statsCardStyles = {
  card: {
    background: COLORS.bgCard,
    borderRadius: '12px',
    padding: '16px',
    border: `1px solid ${COLORS.borderSecondary}`,
  },

  title: {
    fontSize: '14px',
    color: COLORS.textSecondary,
    marginBottom: '8px',
  },

  value: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: COLORS.textGold,
  },

  subValue: {
    fontSize: '12px',
    color: COLORS.textSecondary,
    marginTop: '4px',
  },

  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
    gap: '12px',
    marginBottom: '20px',
  },
};

// ========================================
// モーダル/ダイアログ
// ========================================

export const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    padding: '20px',
  },

  content: {
    background: COLORS.bgCard,
    borderRadius: '16px',
    padding: '24px',
    maxWidth: '600px',
    width: '100%',
    maxHeight: '80vh',
    overflow: 'auto',
    border: `2px solid ${COLORS.borderPrimary}`,
  },

  contentMobile: {
    padding: '16px',
    maxHeight: '90vh',
  },
};

// ========================================
// ボタン
// ========================================

export const buttonStyles = {
  primary: {
    padding: '12px 24px',
    border: 'none',
    borderRadius: '8px',
    background: `linear-gradient(135deg, ${COLORS.accent} 0%, ${COLORS.accentLight} 100%)`,
    color: '#fff',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
    transition: 'all 0.2s ease',
  },

  secondary: {
    padding: '12px 24px',
    border: `2px solid ${COLORS.borderPrimary}`,
    borderRadius: '8px',
    background: 'transparent',
    color: COLORS.textPrimary,
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
    transition: 'all 0.2s ease',
  },

  small: {
    padding: '6px 12px',
    fontSize: '12px',
  },

  disabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
};

export default {
  COLORS,
  screenStyles,
  navStyles,
  filterStyles,
  gridStyles,
  detailStyles,
  progressStyles,
  statsCardStyles,
  modalStyles,
  buttonStyles,
};
